/**
 * @generated SignedSource<<86fddc916327361e7ab748ebf04c2420>>
 * @relayHash 5f9b53beadf528e357195968393074f5
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5f9b53beadf528e357195968393074f5

import { ConcreteRequest } from 'relay-runtime';
export type Ch_approveAndGenerateCarePlanDocumentInput = {
  keepOriginalAuthor: boolean;
  progressNoteId: string;
};
export type chApproveAndGenerateCarePlanDocumentMutation$variables = {
  connections: ReadonlyArray<string>;
  input: Ch_approveAndGenerateCarePlanDocumentInput;
};
export type chApproveAndGenerateCarePlanDocumentMutation$data = {
  readonly approveAndGenerateCarePlanDocument: {
    readonly carePlanSummary: {
      readonly createdAt: string;
      readonly createdBy: string;
      readonly fileId: string | null;
      readonly fileMetadata: {
        readonly documentType: string;
        readonly extension: string;
        readonly lengthInKilobytes: number;
      } | null;
      readonly id: string;
      readonly progressNoteId: string;
      readonly signedAt: string | null;
      readonly signedBy: string | null;
      readonly treatmentPlan: {
        readonly followUpTreatment: string;
        readonly from: any;
        readonly recommendedTreatment: string;
        readonly title: string;
        readonly to: any;
      };
      readonly updatedAt: string | null;
      readonly updatedBy: string | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type chApproveAndGenerateCarePlanDocumentMutation = {
  response: chApproveAndGenerateCarePlanDocumentMutation$data;
  variables: chApproveAndGenerateCarePlanDocumentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "CarePlanSummary",
  "kind": "LinkedField",
  "name": "carePlanSummary",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CarePlanTreatmentPlan",
      "kind": "LinkedField",
      "name": "treatmentPlan",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "followUpTreatment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recommendedTreatment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "from",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "to",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressNoteId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DocumentFileMetadata",
      "kind": "LinkedField",
      "name": "fileMetadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "extension",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lengthInKilobytes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chApproveAndGenerateCarePlanDocumentMutation",
    "selections": [
      {
        "alias": "approveAndGenerateCarePlanDocument",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_approveAndGenerateCarePlanDocumentPayload",
        "kind": "LinkedField",
        "name": "ch_approveAndGenerateCarePlanDocument",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chApproveAndGenerateCarePlanDocumentMutation",
    "selections": [
      {
        "alias": "approveAndGenerateCarePlanDocument",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_approveAndGenerateCarePlanDocumentPayload",
        "kind": "LinkedField",
        "name": "ch_approveAndGenerateCarePlanDocument",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "carePlanSummary",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "Ch_carePlanSummaryEdge"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "5f9b53beadf528e357195968393074f5",
    "metadata": {},
    "name": "chApproveAndGenerateCarePlanDocumentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c73518d3bed5f3feebc1e85c9e707a52";

export default node;
